export default __webpack_public_path__ + "static/media/icon-unlock-color-white.09b585a4.svg";